import {
  connect
} from 'react-redux'
import { getCampaignById, getDisplayChannelAggregated, getDisplayChannelStatsAggregated, setReportDateRange, setSegmentId,
  setChannelCampaignId, clearCampaignDetail, getCampaignTopLinkStats, getCampaignTopLocationClickStats } from '../../actions/Campaign'
import {selectClient} from "../../actions/App";

import DisplayChannelReport from '../../components/Campaigns/Report/DisplayChannelReport'

const mapStateToProps = (state) => {
  const { clients } = state.app;
  const { displayAggregatedReport, displayAggregatedStats, reportDateRange, campaignDetail, topLinkStats,topLocationOpensStats,
    channelCampaignId, segmentId } = state.campaigns
	return {
    displayAggregatedReport,
    displayAggregatedStats,
    campaignDetail,
    channelCampaignId,
    topLocationOpensStats,
    topLinkStats,
    segmentId,
		reportDateRange : reportDateRange ? reportDateRange : "life-of-campaign",
		client_id: state.app.client_info && state.app.client_info.id,
    client_tz: state.app.client_info && state.app.client_info.timezone,
		client_info: state.app.client_info,
		clients
	}
}

const mapDispatchToProps = (dispatch) => {
  return {
    getCampaignById(id) {
      dispatch(getCampaignById(id, false));
    },
    selectClient(cid) {
			dispatch(selectClient(cid))
    },
    getDisplayChannelAggregatedReport(groupCampaignId, deploymentid, dateRange, channelCampaignId) {
      dispatch(getDisplayChannelAggregated(groupCampaignId, deploymentid, dateRange, channelCampaignId));
    },
    getDisplayChannelStatsAggregated(groupCampaignId, deploymentid, dateRange, channelCampaignId) {
      dispatch(getDisplayChannelStatsAggregated(groupCampaignId, deploymentid, dateRange, channelCampaignId));
    },
    getCampaignTopLinkStats(groupCampaignId, campaignid, dateRanges, limit) {
      dispatch(getCampaignTopLinkStats(groupCampaignId, campaignid, dateRanges, limit, "display"));
    },
    getCampaignTopLocationClickStats(groupCampaignId, campaignId, dateRange, limit) {
      dispatch(getCampaignTopLocationClickStats(groupCampaignId, campaignId, dateRange, limit, "display"));
    },
    setReportDateRange(dateRange) {
      dispatch(setReportDateRange(dateRange.value));
    },
    setChannelCampaignId(data) {
      dispatch(setChannelCampaignId(data.value))
    },
    setSegmentId(data) {
      dispatch(setSegmentId(data.value))
    },
    cleanCampaignInfo(cid) {
      dispatch(clearCampaignDetail(cid))
    }
  }
}

const DisplayChannelContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(DisplayChannelReport)

export default DisplayChannelContainer


// WEBPACK FOOTER //
// ./src/containers/Campaigns/DisplayChannelReport.js